import Param from '../../param';
import effectManager from '../effect';
import Util from '../../util';
import MainvisualManager from './mainvisual';

const param = new Param();
const effect = new effectManager();
const util = new Util();

let $d3g = {};
d3threeD($d3g);

export default class webglManager {
    constructor(w,h) {

        this.w = w;
        this.h = h;

        this.pixelRato = window.devicePixelRatio;
        // this.pixelRato = 0.8;
        this.renderMode = "normal"; /* low || normal FPSが低下していたら切り替え */

        this.mainvisual = new MainvisualManager(w,h);
        // this.bg = new bgManager();

        this.time=0;

        this.status ={
            render :{
                mainvisual : true,
            }
        }


    }
    init() {

        this.mainvisual.init(this.w,this.h,this.pixelRato);


    }
    change(current,prev){

        this.mainvisual.change(current,prev);

    }
    playMovie(current,type){
        this.mainvisual.playMovie(current,type);
    }
    productBgchange(current,texNo){
        this.mainvisual.productBgchange(current,texNo);
    }
    render(scrollInc,mouse,fpsRate){

        this.time++;


        this.mainvisual.render(mouse,this.time,fpsRate);
    }
    resize(w,h){

        this.w = w;
        this.h = h;

        this.mainvisual.resize(this.w,this.h);

    }
    datGui(){

        let _gui = new dat.gui.GUI();

        _gui.remember(effect);

        let _f1 = _gui.addFolder('Dots');

        // console.log(this.dots);
        //
        // _f1.add(this.dots.mesh[0].position, 'z', -10.00, 10.00);


    }

}